import React from "react"
import PropTypes from "prop-types"
import dayjs from "dayjs"

class DateTime extends React.PureComponent {
  static propTypes = {
    date: PropTypes.any,
    dateTime: PropTypes.any,
    time: PropTypes.any,
  }

  render() {
    const { date, dateTime, time } = this.props
    if (date) {
      return <span className={"DateTime"}>{dayjs(date).format("YYYY/MM/DD")}</span>
    } else if (dateTime) {
      return <span className={"DateTime"}>{dayjs(dateTime).format("YYYY/MM/DD HH:mm")}</span>
    } else if (time) {
      return <span className={"DateTime"}>{dayjs(time).format("HH:mm:ss")}</span>
    } else {
      return null
    }
  }
}

export default DateTime
